module.exports = __webpack_public_path__ + "static/media/TCS.jpg:Zone.338ea86c.Identifier";